/* Keep original description nodes and Dawn's purchase flow intact. */
if (!customElements.get('alfresco-details')) {
  customElements.define('alfresco-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('[data-description]');
      if (!source) return;
      this.dataset.ready = 'true';
      const names = ['Overview', 'Dimensions & specifications', 'Installation & care', 'Shipping & returns'];
      const groups = names.map(() => document.createDocumentFragment());
      let current = 0;
      [...source.childNodes].forEach(node => {
        if (/^H[1-6]$/.test(node.nodeName)) {
          const title = node.textContent.toLowerCase();
          current = /shipping|returns/.test(title) ? 3 : /install|suitability|care|outdoor exposure|ip65/.test(title) ? 2
            : /specification|dimension|size|weight|technical|diagram/.test(title) ? 1 : 0;
        }
        groups[current].append(node);
      });
      const policies = this.querySelector('[data-policies]');
      if (policies) groups[3].append(...policies.childNodes);
      const nav = document.createElement('div');
      nav.className = 'alfresco-tabs'; nav.setAttribute('role', 'tablist'); nav.setAttribute('aria-label', 'Product information');
      const panels = [], tabs = [];
      const prefix = `details-${this.closest('product-info, [data-alfresco-product]')?.dataset.section || 'product'}`;
      groups.forEach((content, index) => {
        if (!content.textContent.trim() && !content.querySelector('img,table,video')) return;
        const panel = document.createElement('details');
        panel.id = `${prefix}-${index}`; panel.className = 'alfresco-panel';
        const summary = document.createElement('summary'); summary.textContent = names[index];
        const body = document.createElement('div'); body.className = 'alfresco-panel-content rte'; body.append(content);
        panel.append(summary, body); panels.push(panel);
        const tab = document.createElement('button'); tab.type = 'button'; tab.textContent = names[index];
        tab.id = `${panel.id}-tab`; tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panel.id);
        tab.addEventListener('click', () => select(panels.indexOf(panel)));
        tabs.push(tab); nav.append(tab);
      });
      let active = 0;
      const mobile = window.matchMedia('(max-width: 749px)');
      const select = index => {
        active = index;
        tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1;});
        panels.forEach((panel, i) => {panel.open = i === index;});
      };
      nav.addEventListener('keydown', event => {
        const key = event.key;
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(key)) return;
        event.preventDefault();
        const index = key === 'Home' ? 0 : key === 'End' ? tabs.length - 1 : (active + (key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(index); tabs[index].focus();
      });
      const mode = () => {
        panels.forEach((panel, index) => {
          if (mobile.matches) {panel.removeAttribute('role');panel.removeAttribute('aria-labelledby');}
          else {panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs[index].id);}
        });
        select(active);
      };
      this.replaceChildren(nav, ...panels);
      this.querySelectorAll('table').forEach(table => {
        const wrapper = document.createElement('div');wrapper.className = 'alfresco-table-scroll';wrapper.tabIndex = 0;
        wrapper.setAttribute('role','region');wrapper.setAttribute('aria-label','Product specifications table; scroll horizontally for more columns');
        table.before(wrapper);wrapper.append(table);
      });
      mode(); mobile.addEventListener('change', mode);
      this.cleanup = () => mobile.removeEventListener('change', mode);
      const intro = this.querySelector('.alfresco-panel-content p');
      const target = this.closest('product-info, [data-alfresco-product]')?.querySelector('[data-alfresco-intro]');
      if (intro && target) {
        const text = intro.textContent.trim();
        target.textContent = text.match(/^.{1,260}?[.!?](?:\s|$)/)?.[0]?.trim() || (text.length <= 260 ? text : text.slice(0, 240).replace(/\s+\S*$/, '') + '…');
      }
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
if (!customElements.get('alfresco-buybar')) {
  customElements.define('alfresco-buybar', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const product = this.closest('product-info, [data-alfresco-product]');
      if (!product) return;
      const section = product.dataset.section;
      const button = this.querySelector('[data-buy]');
      const sync = () => {
        const original = product.querySelector(`#ProductSubmitButton-${section}, [data-ai-atc]`);
        const priceBox = product.querySelector(`#price-${section}, [data-ai-price]`);
        const price = product.querySelector(`#price-${section} .price-item--regular`) || priceBox;
        if (!original) {this.hidden = true;return;}
        this.hidden = false;
        button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true' || original.classList.contains('loading');
        button.textContent = original.querySelector('span')?.textContent.trim() || original.textContent.trim();
        const currentPrice = product.querySelector(`#price-${section} .price--on-sale .price__sale .price-item--sale`) || price;
        const priceCopy = currentPrice?.cloneNode(true);
        priceCopy?.querySelectorAll('.sr-only, .visually-hidden, .line-through').forEach(node => node.remove());
        this.querySelector('[data-price]').textContent = priceBox?.classList.contains('hidden') ? '' : (priceCopy?.textContent.trim() || '');
      };
      button.addEventListener('click', () => {
        const original = product.querySelector(`#ProductSubmitButton-${section}, [data-ai-atc]`);
        if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') original.click();
      });
      this.observer = new MutationObserver(sync);
      const info = product.querySelector(`#ProductInfo-${section}, .product-info`);
      if (info) this.observer.observe(info, {childList:true,subtree:true,attributes:true,characterData:true});
      sync();
    }
    disconnectedCallback() { this.observer?.disconnect();this.observer = null; }
  });
}
